import { useQuery } from "@tanstack/react-query";
import { firstValueFrom } from "rxjs";
import documentService from "services/documentService";
import React from "react";
import { CircularProgress, Stack } from "@mui/material";
export type BrowserNativePdfViewerProps = {
  documentId: string;
  serviceUrl: string;
};

export function BrowserNativePdfViewer({
  documentId,
  serviceUrl,
}: BrowserNativePdfViewerProps) {
  const { data: url, isLoading } = useQuery({
    enabled: !!documentId,
    queryKey: ["pdfDocument", documentId],
    queryFn: async () => {
      const observable$ = documentService.getDocumentById$(documentId, serviceUrl);
      const blob = await firstValueFrom(observable$);
      return URL.createObjectURL(blob);
    },
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 60,
    retry: 1,
    refetchOnWindowFocus: false,
  });


  if(isLoading) {
    return (
          <Stack
            justifyContent="center"
            alignItems="center"
            sx={{
              width: "100%",
              height: "100%",
            }}
          >
            <CircularProgress size={50} />
          </Stack>
        );
  }
  if (!url) {
    return null;
  }
  return (
    <object
      data={url}
      type="application/pdf"
      width="100%"
      height="100%"
    >
      <p>
        Your browser can’t display PDFs inline.
        <a href={url} download>
          Download the PDF
        </a>
      </p>
    </object>
  );
}
